import { render, staticRenderFns } from "./newMyPage.vue?vue&type=template&id=5eea0e90&lang=pug&"
import script from "./newMyPage.vue?vue&type=script&lang=js&"
export * from "./newMyPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports